module.exports = __webpack_public_path__ + "img/IT0000219180739.b97f3ffd.png";